import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import useDebounce from '@/common/hooks/useDebounce.ts';
import { countyRequest } from '@/common/queries/selections/countyRequest';

const useCountyRequest = (province: number | undefined) => {
  const [countyName, setCountyName] = useState<string>('');
  const debounce = useDebounce();
  const onCountySearchChange = (value: string) => {
    if (value) {
      debounce(() => {
        setCountyName(value);
      }, 1000);
    } else {
      setCountyName(value);
    }
  };

  const countyQuery = useQuery({
    enabled: !!province,
    queryKey: ['county', province, countyName],
    staleTime: 1000 * 60 * 10,
    gcTime: 1000 * 60 * 30,
    queryFn: () => countyRequest({ province, countyName }),
    select: (data) =>
      data.results.map((item) => ({ label: item.name, value: item.id })),
  });
  return { countyQuery, onCountySearchChange };
};

export default useCountyRequest;
